export const styles = theme => ({
    main: {
        backgroundColor: 'white',
        paddingTop: '5px',
    },
    rangeDesktop: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'inline'
        }
    },
    rangeMobile: {
        display: 'inline-flex',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            display: 'none'
        }
    },
    scheduleTable: {
        '& .daysRow': {
            position:'sticky'
        },
        '& .cellEnhancedStyle': {
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#212121'
        }
    },
});
